import React, {useState} from 'react';
import PropTypes from 'prop-types';
import { Client } from '../../client';
import { LazyImageList, withImageLoad } from '../LazyImageList';

const ContrastList = withImageLoad(LazyImageList, Client.getRemarkImageUrl)

import FabricSearch from '../FabricHeader/FabricSearch';
import FabricInfo from '../FabricInfo/FabricInfo';
import RitModal from '../RitModal';

/* styled */
import {
    SelectedContrast,
    ContrastLabel,
    CloseIcon,
    SearchWrapper
} from './styled';
import { FieldWrapper } from '../Styled';

const ContrastsSectionComponent = (options) => {
    const {
        values,
        value,
        isMobile,
        onChange,
        onFabricCancel,
        onFabricSearch,
        openModal,
        closeModal,
        isModalOpened,
        disabled,
        searchTerm,
    } = options;

    const [fabricPreview, setFabricPreview] = useState(null);

    //При выборе ткани возвращать наверх должен - Nataliia Melnikova
    const scrollToTop = () => {
        if(isMobile) {
            const position = document.querySelector('.b-content-wrapper').scrollHeight - document.querySelector('.config-options-wrapper').scrollHeight;
            window.scrollTo({ top: position, behavior: 'smooth' });
        } else {
            document.querySelector('[name="detail"] > div:first-child').scrollTo({ top: 0, behavior: 'smooth' });
        }
    };

    let contrastFabricSelector;
    if (value && value.displayName) {
        contrastFabricSelector = (
            <SelectedContrast>
                <ContrastLabel>
                    {value.shortName}
                </ContrastLabel>
                <CloseIcon onClick={onFabricCancel} />
            </SelectedContrast>
        )
    } else {
        contrastFabricSelector = (
            <SelectedContrast>
                <ContrastLabel>
                    ВЫБЕРИТЕ ТКАНЬ КОНТРАСТА
                </ContrastLabel>
            </SelectedContrast>
        )
    }

    let popup = (
        <RitModal
            isOpened={isModalOpened}
            title='Ткань контраста'
            onClose={closeModal}
            closeOnEsc={true}
        >
            <FabricInfo
                isMobile={isMobile}
                onRequestClose={closeModal}
                {...fabricPreview}
            />
        </RitModal>
    )

    const listClass = !disabled ? 'lazy-image-list' : 'lazy-image-list lazy-image-list_disabled'

    return (
        <FieldWrapper>
            {contrastFabricSelector}
            <SearchWrapper>
                <FabricSearch
                    term = {searchTerm}
                    onSearch={onFabricSearch}
                    isMobile={isMobile}
                />
            </SearchWrapper>
            <ContrastList
                className={listClass}
                onChange={!disabled ? (e) => { scrollToTop(); onChange(e); } : ()=>{}}
                value={value}
                items={values}
                onFabricInfoClicked={openModal}
                onFabricHoverIn={(v) => { setFabricPreview(v)}}
                onFabricHoverOut={() => { setFabricPreview(null) }}
            />
            {popup}
        </FieldWrapper>
    )
}

ContrastsSectionComponent.propTypes = {
    values: PropTypes.array.isRequired,
    value: PropTypes.object.isRequired,
    isMobile: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    onFabricCancel: PropTypes.func.isRequired,
    onFabricSearch: PropTypes.func.isRequired,
    openModal: PropTypes.func.isRequired,
    closeModal: PropTypes.func.isRequired,
    isModalOpened: PropTypes.bool,
    disabled: PropTypes.any.isRequired,
    searchTerm: PropTypes.string,
}

export default ContrastsSectionComponent;